import { Grid, Typography } from '@mui/material'

export const EventRender = ({ event }) => {
  return (
    <Grid
      container
      sx={{
        backgroundColor: '#add8f7',
        height: '100%',
        borderRadius: 1,
        boxShadow: 1,
        mt: '-5px',
        p: 1.2,
      }}
    >
      <Grid item xs={12}>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 400,
            color: '#000',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {event.data?.[3]}
        </Typography>
      </Grid>
    </Grid>
  )
}
